export const PARTNERS = {
    ENVIOS_NOW: 'envios now',
    FAZT: 'fazt',
    STGO_COURIER: 'stgo courier'
}
export const PARTNERS_TEXT = {
    [PARTNERS.ENVIOS_NOW]: 'Envios Now',
    [PARTNERS.FAZT]: 'Fazt',
    [PARTNERS.STGO_COURIER]: 'Stgo Courier'
}

